export default __webpack_public_path__ + "static/media/trash.528fb5f4.svg";